/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSyncAlt
} from '@fortawesome/free-solid-svg-icons';
import { ConfigContext } from '../../context/config.context';
import connect from '../../views/axios/axios.auth';
  
const SemanalGrafico = ({ data }) => {

    const { config, setConfiguracion } = useContext(ConfigContext);
    const [actualizando, setActualizando] = useState(false);
    
    const [dataGrafico, setGrafico] = useState({     
        series: [],
        options: {
          chart: {
            height: 350,
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          colors: [],
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Resumen de guias (Semana actual)',
            align: 'left'
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 1
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Días semana actual'
            }
          },
          yaxis: {
            title: {
              text: 'Guias Semana Actual'
            },
            min: 5,
            max: 40
          },
          legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
          }
        },
      })

    useEffect(() => {
      if (data.graficos) {         
          setGrafico({
              ...dataGrafico,
              series: data.graficos.series,
              options: {
                ...dataGrafico.options,
                colors: data.graficos.colors,
                xaxis: {
                    categories: data.graficos.categories,
                    title: {
                      text: 'Días semana actual'
                    }
                  },
                yaxis: {
                title: {
                    text: 'Guias Semana Actual'
                },
                min: data.graficos.maxMin.min,
                max: data.graficos.maxMin.max
                },
              }
          })
      }
    },[data]);


    const actualizardata = async () => {
        setActualizando(true);
        const graficos = await connect.post(`/reportes/semana-envios`);
        if (graficos.status === 200) {
            setConfiguracion({...config, graficos: graficos.data });
        }
        setActualizando(false);
    }

    return (
        <div id="chart">
            {actualizando && <div className="preloader-grafico">Actualizando</div> }
            <ReactApexChart 
                options={dataGrafico.options}
                series={dataGrafico.series}
                type="line"
                height={350}
            />
            <button onClick={actualizardata} type="button" className="btnx btnx-warn sync-grafico">
                <FontAwesomeIcon icon={faSyncAlt} />
            </button>
        </div>     
    )
}

export default SemanalGrafico;